import React, {useCallback} from 'react'
import PropTypes from 'prop-types'
import {Box, useBreakpointValue, useDisclosure} from '@chakra-ui/react'
import useSWR from 'swr'
import {fetcher} from '~/api'
import {camelizeResult, dineroMoneyObjects} from '~/api/serializer'
import PaymentsDrawer from '../PaymentsDrawer'
import Large from './Large'
import Medium from './Medium'

const PaymentsTable = ({supplierId}) => {
  const {data, isLoading} = useSWR(
    `/points_on_payments/api/suppliers/${supplierId}/payments`,
    fetcher,
    {
      use: [camelizeResult, dineroMoneyObjects],
    },
  )

  const {payments = []} = data || {}

  const {isOpen, onOpen, onClose} = useDisclosure()
  const [selectedPaymentId, setSelectedPaymentId] = React.useState(null)
  const selectedPayment = payments.find(({id}) => id === selectedPaymentId)

  const showPayment = useCallback(
    ({id}) => {
      setSelectedPaymentId(id)
      onOpen()
    },
    [onOpen],
  )

  const isLarge = useBreakpointValue({base: false, xl: true})

  return (
    <>
      <PaymentsDrawer
        payment={selectedPayment}
        isOpen={isOpen}
        onClose={onClose}
      />
      <Box id="bill-payments-table" data-testid="bill-payments-table">
        {isLarge ? (
          <Large
            payments={payments}
            isLoading={isLoading}
            onClickRow={showPayment}
          />
        ) : (
          <Medium
            payments={payments}
            isLoading={isLoading}
            onClickPayment={showPayment}
          />
        )}
      </Box>
    </>
  )
}

PaymentsTable.propTypes = {
  supplierId: PropTypes.string.isRequired,
}

export default PaymentsTable
